module.exports = __webpack_public_path__ + "static/media/heat.deed4d5a.svg";